import { gql, TypedDocumentNode } from '@apollo/client';

import { QueryGetJobPositionsSalaryEstimationArgs, SalaryEstimationDto } from '@pflegia/data-access';

export const GET_JOB_POSITIONS_SALARY_ESTIMATIONS: TypedDocumentNode<
  { data?: SalaryEstimationDto },
  QueryGetJobPositionsSalaryEstimationArgs
> = gql`
  query getJobPositionsSalaryEstimation($filters: JobPositionsSalaryEstimationInput!) {
    data: getJobPositionsSalaryEstimation(filters: $filters) {
      averageSalary
      averageMaxSalary
      averageMinSalary
    }
  }
`;
